import { formatPercentageInputValue, percentageMask } from "../../utils/admin-utils";

export const latePaymentPenaltyFormConfig = ({ paymentPenalty } = {}) => {
	return [
		{
            fields: [
                {
                    name: "delinquencyGreaterThan",
                    label: "% de inadimplência (maior que) *",
                    type: "text",
                    placeholder: "0",
                    defaultValue: formatPercentageInputValue(paymentPenalty?.delinquencyGreaterThan),
                    columns: 12,
                    onChange: percentageMask
                },
                {
                    name: "penalty",
                    label: "% de penalidade *",
                    type: "text",
                    placeholder: "0",
                    defaultValue: formatPercentageInputValue(paymentPenalty?.penalty),
                    columns: 12,
                    onChange: percentageMask
                }
            ]
        }
	];
};